<template>
  <section
    :class="[
      'relative h-120 md:h-180 w-full bg-gray-lightest bg-no-repeat bg-cover',
      {
        'animate-pulse': loading,
      },
    ]"
    :style="style"
  >
    <div
      class="absolute inset-0 bg-no-repeat bg-cover"
      :style="`background-image: url('${image}'); background-position: ${bgPosition}`"
    ></div>
    <div
      v-if="gradient || !image"
      class="absolute inset-0 bg-gradient-to-r from-black/75 to-black/25"
    ></div>
    <div class="absolute inset-0 py-8 md:py-16">
      <div class="container w-full h-full">
        <div class="relative w-full h-full">
          <div class="absolute top-0 left-0 lg:w-1/2">
            <h1 v-if="title" class="headline text-white font-bold mb-4">
              {{ title }}
            </h1>
            <p
              v-if="subtitle"
              class="max-w-[50%] line-clamp-5 md:line-clamp-none text-white"
            >
              {{ subtitle }}
            </p>
          </div>

          <div
            v-if="hasCaptionSlot"
            class="absolute top-0 right-0 hidden lg:w-1/2"
          >
            <slot name="caption"></slot>
          </div>

          <div v-if="hasCtaSlot" class="absolute bottom-0 left-0 w-1/2">
            <slot name="cta"></slot>
          </div>

          <div v-if="hasControlsSlot" class="absolute bottom-0 left-0 w-1/2">
            <slot name="cta"></slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: null,
    },

    image: {
      type: String,
      default: '',
    },

    gradient: {
      type: Boolean,
      default: false,
    },

    bgPosition: {
      type: String,
      default: 'center',
    },

    preload: {
      type: Boolean,
      default: false,
    },
  },

  head() {
    return {
      ...(this.preload && this.image
        ? {
            link: [
              {
                rel: 'preload',
                as: 'image',
                href: this.$img('/assets/img/ucrs-placeholder.png'),
                fetchpriority: 'high',
              },
              {
                rel: 'preload',
                as: 'image',
                href: this.image,
                fetchpriority: 'high',
              },
            ],
          }
        : {}),
    }
  },

  computed: {
    hasCtaSlot() {
      return !!this.$slots.cta
    },

    hasCaptionSlot() {
      return !!this.$slots.caption
    },

    hasControlsSlot() {
      return !!this.$slots.controls
    },
    style() {
      return `background-image: url('${this.$img(
        '/assets/img/ucrs-placeholder.png'
      )}'); background-position: ${this.bgPosition}`
    },
  },
}
</script>
